import React, { ReactNode } from "react";
import { RouteComponentProps } from "react-router-dom";

import { Icon } from "../../../../../..";
import { translate } from "../../../../../../../services/translation.service";

export interface IFooterItemOnClick {
  closeMenu?: () => void;
  router?: Partial<RouteComponentProps>;
}

export interface IFooterItem {
  getText: (me?: boolean) => string;
  getTarget?: (me?: boolean) => string;
  onClick?: (e: React.MouseEvent, params: IFooterItemOnClick) => void;
  renderIcon: () => ReactNode;
}

export const footerItemsDictionary: IFooterItem[] = [
  {
    getTarget: (): string => translate("links.home"),
    getText: (): string => translate("menu.home"),
    onClick: (e: React.MouseEvent, params: IFooterItemOnClick): void => {
      params.closeMenu!();
    },
    renderIcon: (): ReactNode => <Icon name="home" size={24} />,
  },
  {
    getTarget: (me?: boolean): string =>
      me
        ? translate("links.customerAccount")
        : translate("links.customerAccountLogin"),
    getText: (me?: boolean): string =>
      me ? translate("menu.account") : translate("menu.signIn"),
    onClick: (e: React.MouseEvent, params: IFooterItemOnClick): void => {
      params.closeMenu!();
    },
    renderIcon: (): ReactNode => <Icon name="profile" size={24} />,
  },
  {
    getTarget: (): string => translate("links.stores"),
    getText: (): string => translate("menu.stores"),
    onClick: (e: React.MouseEvent, params: IFooterItemOnClick): void => {
      params.closeMenu!();
    },
    renderIcon: (): ReactNode => <Icon name="repere-1" size={24} />,
  },
  {
    getTarget: (): string => translate("links.hcRequestsNew"),
    getText: (): string => translate("menu.sav"),
    onClick: (e: React.MouseEvent, params: IFooterItemOnClick): void => {
      params.closeMenu!();
    },
    renderIcon: (): ReactNode => <Icon name="at" size={24} />,
  },
];
